var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button is-square is-icon is-info has-background-dark",on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_c('dp-svg',{staticClass:"is-tiny",attrs:{"svg":_vm.svg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }